// TODO: add flow types

import spaCategories from './factories/spaCategories';

/**
 * Path: /schoenheit-und-gesundheit/spa
 * Renders all categories with type "spa" (eg. Körperanwendungen, Massagen, …)
 */
export default spaCategories('spa', 'SPA & Meer', 'spa-more');
